import { useTranslation } from 'react-i18next'
import { Box, TextField, MenuItem, InputAdornment, Typography } from '@mui/material'
import { Person } from '@mui/icons-material'
import { DEMO_LOGIN_USERS } from '@/components/auth/demoLoginUsers'

interface DemoQuickLoginBlockProps {
  value: string
  onChange: (email: string) => void
  disabled?: boolean
}

export function DemoQuickLoginBlock({ value, onChange, disabled }: DemoQuickLoginBlockProps) {
  const { t } = useTranslation()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <TextField
        select
        fullWidth
        id="demo-login-user"
        label={t('auth.demoPickUser')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        InputLabelProps={{ shrink: true }}
        SelectProps={{
          displayEmpty: true,
          renderValue: (selected) => {
            if (selected === '') {
              return (
                <Typography component="span" color="text.secondary" sx={{ typography: 'body1' }}>
                  {t('auth.demoSelectPlaceholder')}
                </Typography>
              )
            }
            const u = DEMO_LOGIN_USERS.find((x) => x.email === selected)
            return u ? t(u.labelKey) : String(selected)
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Person color="action" />
            </InputAdornment>
          ),
        }}
      >
        <MenuItem value="">
          <Typography color="text.secondary" component="span">
            {t('auth.demoSelectPlaceholder')}
          </Typography>
        </MenuItem>
        {DEMO_LOGIN_USERS.map((u) => (
          <MenuItem key={u.email} value={u.email}>
            {t(u.labelKey)}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  )
}
